import React from "react";
// import './index.css';
// import './Rsuite.css';
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/style.scss";
import "./assets/css/Brand.scss";
import "./assets/css/BrandResponsive.scss";
import "./assets/css/Brand.scss";
import "./assets/css/InfluencerResponsive.scss";
import "./color.css";
import "aos/dist/aos.css";
import App from "./App";

import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import AuthContext from "./Contexts/AuthContext";
import { createRoot } from "react-dom/client";
import { Bounce, ToastContainer } from "react-toastify";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <AuthContext>
    {/* <BrowserRouter basename="/frontend"> */}
    <BrowserRouter>
      <div className="relative pb-0">
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          transition={Bounce}
        />
        <App />
      </div>
    </BrowserRouter>
  </AuthContext>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
